import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import palceholderimage from "../../../assets/images/palceholderimage.webp";
import women from "../../../assets/images/HomePage/women.webp";
import men from "../../../assets/images/HomePage/men.webp";
import bags from "../../../assets/images/HomePage/bag1.webp";
import accessories from "../../../assets/images/HomePage/acc1.webp";
import shoes from "../../../assets/images/HomePage/shoes1.webp";
import clothes from "../../../assets/images/HomePage/clothcategory.webp";
import watches from "../../../assets/images/HomePage/watch1.webp";
import jewelry from "../../../assets/images/HomePage/jew1.webp";
import { useDispatch } from "react-redux";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  SetBottomSizeFilter,
  resetLoadingNumber,
  getAllProductOnline,
} from "../../../features/Products/ProductSlice";
import { LazyLoadImage } from "react-lazy-load-image-component";

function ShopByCategories() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageLoaded, setImageLoaded] = useState(false);

  const details1 = [
    // {
    //     id: "gender=WFA967se7qX0jYtySgTj",
    //     img: women,

    //     brand:`  ${i18n.language == 'en' ? "WOMEN" : "نساء"}`,
    //     class: `  ${i18n.language == 'en' ? "ps-0" : "ps-2 ps-md-0"}`,
    //     alt:"The Louis Vuitton Eva for women"

    //   },
    // {
    //   id: "gender=KG3s4pPk3arcBux5ERnD",
    //   img: men,
    //   brand:`  ${i18n.language == 'en' ? "MEN" : "رجال"}`,
    //   class: "ps-3 ps-md-3",
    //   alt:"The Céline classic box"

    // },
    {
      id: "id=yJDeEt0uKPxfxtqOM42V",
      img: clothes,
      brand: `  ${i18n.language == "en" ? "Clothes" : "ملابس "}`,
      class: "ps-3 ps-md-3",
      alt: "Clothes: Clothes with the Chanel Gabrielle Hobo bag",
    },
    {
      id: "id=WJmwaMSWxtl1dK1sPZ1x",
      img: shoes,
      brand: `  ${i18n.language == "en" ? "Shoes" : "أحذية"}`,
      class: "ps-3 ps-md-3",
      alt: "Shoes: Amina Muaddi Gilda Glitter Mules",
    },
    {
      id: "id=AqFLulu9y2m4mqEIkch1&",
      img: bags,
      brand: `  ${i18n.language == "en" ? "Bags" : "حقائب يد"}`,
      class: "ps-3 ps-md-3",
      alt: "Bags: Givenchy Antigona leather bag (back) and blue Bottega Veneta Jodie (front)",
    },
    {
      id: "subcategory=kYTvn5wAxopx5jpqotC0",
      img: watches,
      brand: `  ${i18n.language == "en" ? "Watches" : "ساعات"}`,
      class: "ps-3 ps-md-3",
      alt: "Watches: Watches section",
    },
    {
      id: "id=LVw0hUP9kEcd1Qr9CoEk",
      img: accessories,
      brand: `  ${i18n.language == "en" ? "Accessories" : "إكسسوارات"}`,
      class: "ps-3 ps-md-3",
      alt: "Accessories and jewelry",
    },

    {
      id: "id=07kdA6cD3NDKxX8pQ7w1",
      img: jewelry,
      brand: `  ${i18n.language == "en" ? "Jewellery" : "مجوهرات"}`,
      class: "ps-3 ps-md-3",
      alt: "Watches: Watches section",
    },
  ];

  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }

  useEffect(() => {
    dispatch(SortProducts(""));

    dispatch(SetSelectdPage(0));
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
  }, []);
  useEffect(() => {
    const loadImagePromises = details1.map((detail) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = detail.img;

        if (!img.complete) {
          img.onload = () => {
            resolve();
          };
        } else {
          resolve();
        }
      });
    });

    Promise.all(loadImagePromises).then(() => {
      setImageLoaded(true);
    });
  }, []);
  return (
    <>
      <h1 className="title-section px-md-5 pb-md-5 pb-3 " style={arabStyle}>
        {t("SHOP BY CATEGORIES")}
      </h1>

      <div
        className={`row scroll  ${
          i18n.language == "en" ? "ms-0 me-4" : `me-0 ms-4`
        }`}
        id="style-2"
      >
        <div
          className="col-12 d-flex  p-0 px-md-4 justify-content-between   mx-0 "
          id="style-2"
        >
          {details1?.map((detail) => (
            <div
              onClick={() =>
                navigate(`/products?${detail?.id}`) &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" }) &
                dispatch(SetSearch(""))
              }
              className="text-decoration "
              key={detail.id}
              style={{ cursor: "pointer" }}
            >
              <div className={`${detail.class} `}>
                <div className="containercategorie px-0 mx-0">
                  {!imageLoaded && (
                    <div className="categories-img align-items-center d-flex justify-content-center">
                      <div className="loader2 ">
                        <span className="loader__element"></span>
                        <span className="loader__element"></span>
                        <span className="loader__element"></span>
                      </div>
                    </div>
                  )}
                  <LazyLoadImage
                    loading="lazy"
                    src={detail?.img}
                    delayTime={300}
                    className="categories-img"
                    placeholderSrc={palceholderimage}
                    alt={detail?.alt}
                    style={{ display: imageLoaded ? "block" : "none" }}
                  />
                </div>
                <div className="homepagesubtxt text-center pt-1">
                  {detail?.brand}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <br></br>
      {/* <div className="pb-md-5 text-center  pb-lg-5 pt-md-5 pb-md-5" >
    <button
          className="btn-shop buttonH mb-lg-5"
          onClick={() =>
            dispatch(getAllProductOnline([])) &
            dispatch(SetSearch("")) &
            dispatch(SetSelectdPage(0)) &
            dispatch(SetSizeFilter([])) &
            dispatch(SetBottomSizeFilter([]))&
            dispatch(SetTopSizeFilter([])) &
            dispatch(resetLoadingNumber(30))&
            navigate(`/products`) &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          aria-label="Shop All Products"
          
        >
         {t( "SHOP ALL")}
        </button>

    </div> */}
      {/* <div className="text-center pt-lg-5 pt-4 pb-lg-5  pb-5 ">
    
        <button
          className="btn-shop buttonH mb-lg-5"
          onClick={() =>
            dispatch(SetSelectdPage(0)) &
            navigate(`/products`) &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          aria-label="View All Products"
        >
         {t( "SHOP ALL")}
        </button>
      </div> */}
    </>
  );
}

export default ShopByCategories;
